module.exports = __webpack_public_path__ + "media/images/account/icon4-7f1731c70a0e767b5d84bf124ca96b43.svg";